import axios from 'axios';
import { dispatch, getState } from '../../store/Index';
import { generalShowErrorSnackbar } from '../../store/general/Functions';
import { dataSetRoles } from '../../store/data/Actions';
import { IRole } from '../../@types/model/user/role';
import { dataSetRole } from '../../store/data/Functions';
import { IApiError } from '../../@types/other';

export async function getList(name ?: string, code ?: string, isActive ?: boolean) : Promise<Array<IRole>> {
    try {
        const state = getState();

        if (!!state.data.rights.length) {
            return state.data.roles;
        }

        const result = await axios.get<Array<IRole>>(`${API_URL}/v1/Rights/Role/GetList`, {
            params : {
                name,
                code,
                isActive,
            },
        });

        dispatch(dataSetRoles(result.data));
        return result.data;
    } catch (ex) {
        const error = ex as IApiError;
        if (!!error && error.status === 400) {
            generalShowErrorSnackbar(error.data?.Message ?? '');
        } else if (!!error && error.status !== 401 && error.status !== 403) {
            generalShowErrorSnackbar('Error getting roles');
        }
        return [];
    }
}

export async function getRole(roleId : number) : Promise<IRole> {
    try {
        const result = await axios.get<IRole>(`${API_URL}/v1/Rights/Role/GetRole`, {
            params : {
                roleId,
            },
        });

        dataSetRole(result.data);
        return result.data;
    } catch (ex) {
        const error = ex as IApiError;
        if (!!error && error.status === 400) {
            generalShowErrorSnackbar(error.data?.Message ?? '');
        } else if (!!error && error.status !== 401 && error.status !== 403) {
            generalShowErrorSnackbar('Error getting roles');
        }
        return {} as IRole;
    }
}

export async function save(role : IRole) : Promise<IRole | null> {
    try {
        const result = await axios.post<IRole>(`${API_URL}/v1/Rights/Role/Save`, role, {
            params : {
            },
        });

        return result.data;
    } catch (ex) {
        const error = ex as IApiError;
        if (!!error && error.status === 400) {
            generalShowErrorSnackbar(error.data?.Message ?? '');
        } else if (!!error && error.status !== 401 && error.status !== 403) {
            generalShowErrorSnackbar('Error creating role');
        }
        return null;
    }
}

export function getUserRole() : IRole | null {
    const state = getState();

    if (!!!state.auth.session) return null;
    if (!!!state.auth.session.user.role) return null;

    return state.auth.session.user.role;
}

export async function deleteRole(roleId : number) : Promise<boolean> {
    try {
        await axios.delete(`${API_URL}/v1/Rights/Role/Delete`, {
            params : { roleId },
        });

        return true;
    } catch (ex) {
        const error = ex as IApiError;
        if (!!error && error.status === 400) {
            generalShowErrorSnackbar(error.data?.Message ?? '');
        } else if (!!error && error.status !== 401 && error.status !== 403) {
            generalShowErrorSnackbar('Error deleting role');
        }
        return false;
    }
}
